import React from 'react'
import { Link } from 'react-router-dom'

export default function Features2() {
  return (
    <div class='w-full md:max-w-[90%]  mx-auto py-10 relative px-5 flex flex-col justify-center items-center gap-4'>
      <div className='grid md:grid-cols-12 grid-cols-1 gap-10'>
        <div className='flex items-center justify-center mx-auto md:col-span-4 col-span-full'>
          <img
            src='/images/features-6.png'
            alt=''
            className='w-full md:max-w-[656px] max-w-[270px] animate__slideInUp animate__animated wow '
          />
        </div>
        <div className='flex flex-col justify-center md:items-start items-center md:space-y-5 space-y-3 md:col-span-8 col-span-full animate__slideInUp animate__animated wow'>
          <h2 className='md:text-5xl text-2xl animate__slideInUp animate__animated wow'>
            Exclusive NFT Holders{' '}
          </h2>
          <hr
            className='w-[130px]  border-[#FFA800] border block'
            style={{ color: '#FFA800' }}
          />
          <p className='md:text-start text-center md:text-base text-sm animate__slideInUp animate__animated wow'>
            Our exclusive Deep Whales AI NFT Holders, (numbered 1 50), will also
            be entitled to 1.5x of the normal revenue share by holding an NFT in
            the wallet in which they hold their tokens. If any are available,
            these are also available to purchase at
          </p>
          <Link
            hrefLang='https://opensea.io/collection/deep-whales-ai'
            target='_blank'
            className='text-[#F2D199] md:text-start text-center animate__slideInUp animate__animated wow'
          >
            https://opensea.io/collection/deep-whales-ai
          </Link>
        </div>
        <div className='flex md:hidden items-center justify-center mx-auto md:col-span-4 col-span-full after:bg-[#F2CF59] after:bg-opacity-5 after:blur-xl after:backdrop-blur-sm after:w-full after:h-full after:rounded-full after:block after:absolute relative after:top-0 after:-z-10 z-50'>
          <img
            src='/images/features-7.png'
            alt=''
            className='w-full md:max-w-[656px] max-w-[270px] animate__slideInUp animate__animated wow'
          />
        </div>
        <div className='flex flex-col justify-center md:items-start items-center md:space-y-5 space-y-3 md:col-span-8 col-span-full animate__slideInUp animate__animated wow'>
          <h2 className='md:text-5xl text-2xl animate__slideInUp animate__animated wow'>
            Deepmind AI VC Startup Fund
          </h2>
          <hr
            className='w-[130px]  border-[#FFA800] border block'
            style={{ color: '#FFA800' }}
          />
          <p className='md:text-start text-center md:text-base text-sm animate__slideInUp animate__animated wow'>
            We're dedicated to nurturing innovation and entrepreneurship within
            the crypto space through the Deepmind AI VC Startup Fund. This
            initiative will enable users to apply for a Deepmind AI Grant,
            offering the financial support and resources necessary to launch
            their projects. Our aim is to empower visionaries and innovators in
            bringing their ideas to fruition and offer ongoing support
            accessible through our platform. <br /> Our team will be utilising
            this fund in conjunction with our Deep Whales AI bot alerts to
            invest in opportunities presented to us through our platform.  A
            portion of this will go back to our applicable holders and also used
            for startup projects.
          </p>
        </div>
        <div className='md:flex hidden items-center justify-center mx-auto md:col-span-4 col-span-full after:bg-[#F2CF59] after:bg-opacity-5 after:blur-xl after:backdrop-blur-sm after:w-full after:h-full after:rounded-full after:block after:absolute relative after:top-0 after:-z-10 z-50'>
          <img
            src='/images/features-7.png'
            alt=''
            className='w-full md:max-w-[656px] max-w-[220px] animate__slideInUp animate__animated wow'
          />
        </div>
        <div className='flex items-center justify-center mx-auto md:col-span-4 col-span-full after:bg-[#F2CF59] after:bg-opacity-5 after:blur-xl after:backdrop-blur-sm after:w-full after:h-full after:rounded-full after:block after:absolute relative after:top-0 after:-z-10 z-50'>
          <img
            src='/images/features-8.png'
            alt=''
            className='w-full md:max-w-[656px] max-w-[220px] animate__slideInUp animate__animated wow'
          />
        </div>
        <div className='flex flex-col justify-center md:items-start items-center md:space-y-5 space-y-3 md:col-span-8 col-span-full animate__slideInUp animate__animated wow'>
          <h2 className='md:text-5xl text-2xl animate__slideInUp animate__animated wow'>
            Deep Minke Whales Premium Service
          </h2>
          <hr
            className='w-[130px]  border-[#FFA800] border block'
            style={{ color: '#FFA800' }}
          />
          <p className='md:text-start text-center md:text-base text-sm animate__slideInUp animate__animated wow'>
            Deep Minke Whales Premium Bot will be available at no cost to all
            users holding 0.1%. The same fee structure applies as above. Users
            who do not hold 0.1% minimum will incur a monthly cost of $100 to
            access the Premium Features of our Deep Whales Bot. Exclusive
            features of our Deep Minke Whale Premium Bot will be published via
            medium. However, these include and are not limited to additional
            wallets, Copytrader wallets, faster alerts, faster trading.
          </p>
        </div>
      </div>
    </div>
  )
}
